import React from 'react';
import { Button, Layout } from 'antd';
import { Link } from 'react-router-dom';
import AffiliateList from './components/AffiliateList';

const layout_position = { padding: '0 5%' };

export default function Index() {
    return (
        <Layout style={layout_position}>
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <div>
                    <h3 className="page-title">Manage Affiliates</h3>
                    <h3 className="page-subhead subhead">Manage affiliates for the SuperBike Factory platform .</h3>
                </div>
                <Button type="primary" style={{ marginTop: 20 }}>
                    <Link to="/PlatformManagement/Affiliate_create">Add New Affiliate</Link>
                </Button>
            </div>
            <AffiliateList />
        </Layout>
    );
}



// WEBPACK FOOTER //
// ./src/modules/PlatformManagement/Manage_affiliates/index.js